/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface WebhookListener
 */
export interface WebhookListener {
    /**
     * 
     * @type {string}
     * @memberof WebhookListener
     */
    resourceType: WebhookListenerResourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof WebhookListener
     */
    eventType: string;
    /**
     * 
     * @type {string}
     * @memberof WebhookListener
     */
    url: string;
}

export function WebhookListenerFromJSON(json: any): WebhookListener {
    return {
        'resourceType': json['resourceType'],
        'eventType': json['eventType'],
        'url': json['url'],
    };
}

export function WebhookListenerToJSON(value?: WebhookListener): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'resourceType': value.resourceType,
        'eventType': value.eventType,
        'url': value.url,
    };
}

/**
* @export
* @enum {string}
*/
export enum WebhookListenerResourceTypeEnum {
    POST = 'POST',
    COMMENT = 'COMMENT',
    USER = 'USER'
}


